module.exports = __webpack_public_path__ + "img/banker-green_460.25a33033.png";